<script lang="ts">
    import type { Snippet } from 'svelte';

    interface Props {
        children?: Snippet;
    }

    let { children }: Props = $props();
</script>

<div class="reptile-price__saleTags">
    {@render children?.()}
</div>

<style lang="scss">
    @use '@otto-ec/design-tokens/tokens' as tokens;
    .reptile-price {
        &__saleTags {
            display: flex;
            flex-flow: row wrap;
            align-items: center;
            gap: tokens.$oc-semantic-spacing-50;
            width: 100%;
            margin: tokens.$oc-semantic-spacing-25 0 0;
        }
    }
</style>
